import React, { useState, useEffect, useRef, Fragment } from "react"
import { toast } from "react-toastify"
import { FaSms, FaWhatsapp } from "react-icons/fa"
import { useTranslation } from "react-i18next"

import { IconButton } from "components"
import { sendPaymentLinkSms } from "services"
import { getWhatsappLinkPayMessage, haveAuth } from "utils"
import classes from "./KtOrderCardDropDownSendPaymentLink.module.scss"

const KtOrderCardDropDownSendPaymentLink = props => {
  const { tableOrder, paymentDetail } = props

  const [t] = useTranslation()

  const [loading, setLoading] = useState(false)

  const unmount = useRef(false)

  const handleSendSms = async () => {
    setLoading(true)

    try {
      await sendPaymentLinkSms(tableOrder._id)

      toast.success(t("SMS_ارسال_شد"))
    } catch (err) {
      console.log(err)

      toast.error(t("SMS_ارسال_نشد"))
    }

    if (unmount.current) return

    setLoading(false)
  }

  const handleShareLink = () => {
    const message =
      getWhatsappLinkPayMessage(tableOrder, paymentDetail._id)

    const url =
      `https://api.whatsapp.com/send?phone=${tableOrder.customerMobilePhone}&text=${encodeURIComponent(message)}`

    window.open(url, "_blank")
  }

  useEffect(() => {
    unmount.current = false

    return () => unmount.current = true
  }, [])

  return (
    <Fragment>
      {
        haveAuth(["smsPaymentLink"]) &&
        <button
          className={classes["dropdownItem"]}
          onClick={handleSendSms}
        >
          <IconButton
            size={18}
            icon={FaSms}
            loading={loading}
            loadingColor="black"
          />
          <span className={classes["dropdownText"]}>
            {t("لینک_SMS")}
          </span>
        </button>
      }

      <button
        className={classes["dropdownItem"]}
        onClick={handleShareLink}
      >
        <IconButton
          size={18}
          icon={FaWhatsapp}
          disabled={loading}
          loadingColor="black"
        />
        <span className={classes["dropdownText"]}>
          {t("لینک_واتساپ")}
        </span>
      </button>
    </Fragment>
  )
}

export default KtOrderCardDropDownSendPaymentLink